export default "__VITE_ASSET__CdVru$6J__"